<h2>
    Self Certification
    <ng-content select="[header]"></ng-content>
    <button class="icon--history btn--default" type="button" (click)="showHistory()">View History</button>
</h2><p-table [value]="currentDriverCommercialIntent ? [currentDriverCommercialIntent] : []" styleClass="mvd_table--nest">
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="canEditMedicalReviewSelfCert && actionsEnabled ? 5 : 4">
                No Records Found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th>Certification Type</th>
            <th>Status</th>
            <th>Updated By</th>
            <th>Updated Date</th>
            <th *ngIf="canEditMedicalReviewSelfCert && actionsEnabled" class="w--actions-3">Actions</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data let-expanded="expanded">
        <tr [pSelectableRow]="data">
            <td>{{ data.driverCommercialIntentTypeDisplayValue }}</td>
            <td>{{ data.driverCommercialIntentStatusTypeDisplayValue }}</td>
            <td>{{ data.updatedBy }}</td>
            <td>{{ data.updatedDate | shortDate }}</td>
            <td *ngIf="canEditMedicalReviewSelfCert && actionsEnabled">
                <a class="icon--delete" href="javascript:void(0)" title="Remove Self Certification" (click)="removeSelfCertification(data.id)"></a>
            </td>
        </tr>
    </ng-template>
</p-table>